/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

const RETRYABLE_PATTERNS = [
  'Loading chunk',
  'Loading CSS chunk',
  'Failed to fetch dynamically imported module',
  'chunk',
];

export function isChunkLoadError(error: Error): boolean {
  if (error.name === 'ChunkLoadError') return true;
  return RETRYABLE_PATTERNS.some(p => error.message.includes(p));
}

export function withChunkRetry(
  importFn: () => Promise<any>,
  options: { retryDelay?: number } = {},
) {
  const { retryDelay = 1000 } = options;

  return () => {
    return importFn().catch((error: Error) => {
      if (isChunkLoadError(error)) {
        if ('caches' in window) {
          caches.keys().then(names =>
            Promise.all(names.map(n => caches.delete(n)))
          ).catch(() => {});
        }
        setTimeout(() => window.location.reload(), retryDelay);
        return new Promise(() => {});
      }
      throw error;
    });
  };
}
